function TextRoundLineEditor({line, updateLine, width}) {

    return(
        <div className="selected-text-edition format-regular-container flexColumn flexJustify">
            <div className="title-format">Option de mise en forme</div>
            <div className="font-format-container flexColumn">
                <div className="font-container flexJustify">
                    <select
                        name="font" id="font-select"
                        onChange={(e) => {
                            console.log(e.target.value)
                            updateLine({
                                ...line,
                                fontFamily: e.target.value,
                            });
                        }}
                        value={line.fontFamily}
                    >
                        <option>Arcade</option>
                        <option>Arial</option>
                        <option>Arial Condensed</option>
                        <option>Brush</option>
                        <option>Century</option>
                        <option>Cheltenham</option>
                        <option>Cheltenham Bold</option>
                        <option>Comic</option>
                        <option>Diskus</option>
                        <option>Tahoma</option>
                    </select>

                    <input
                        type="number"
                        id="fontsize-select"
                        name="fontsize"
                        min="2"
                        max="100"
                        onChange={(e) => {
                            updateLine({
                                ...line,
                                fontSize: e.target.value,
                            });
                        }}
                        value={line.fontSize}
                    />

                </div>

                <div className="format-container flexJustify">
                    <button
                        id="bold"
                        className={'format-btn ' + (line.bold ? 'is-selected' : '')}
                        onClick={() => {
                            updateLine({
                                ...line,
                                bold: !line.bold,
                            });
                        }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 18">
                            <defs>
                                <style dangerouslySetInnerHTML={{ __html: '.cls-1{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}' }} />
                            </defs>
                            <title>bold-txt</title>
                            <g id="Calque_2" data-name="Calque 2">
                                <g id="Calque_1-2" data-name="Calque 1">
                                    <path className="cls-1" d="M1,1H9A4,4,0,0,1,9,9H1Z"/>
                                    <path className="cls-1" d="M1,9h9a4,4,0,0,1,0,8H1Z"/>
                                </g>
                            </g>
                        </svg>
                    </button>
                    <button
                        id="italic"
                        className={'format-btn ' + (line.italic ? 'is-selected' : '')}
                        onClick={() => {
                            updateLine({
                                ...line,
                                italic: !line.italic,
                            });
                        }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 18">
                            <defs>
                                <style dangerouslySetInnerHTML={{ __html: '.cls-1{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}' }} />
                            </defs>
                            <title>italic-txt</title>
                            <g id="Calque_2" data-name="Calque 2">
                                <g id="Calque_1-2" data-name="Calque 1">
                                    <line className="cls-1" x1="15" y1="1" x2="6" y2="1"/>
                                    <line className="cls-1" x1="10" y1="17" x2="1" y2="17"/>
                                    <line className="cls-1" x1="11" y1="1" x2="5" y2="17"/>
                                </g>
                            </g>
                        </svg>
                    </button>
                    <button
                        id="underline"
                        className={'format-btn ' + (line.underline ? 'is-selected' : '')}
                        onClick={() => {
                            updateLine({
                                ...line,
                                underline: !line.underline,
                            });
                        }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 20">
                            <defs>
                            </defs>
                            <title>underline-txt</title>
                            <g id="Calque_2" data-name="Calque 2">
                                <g id="Calque_1-2" data-name="Calque 1">
                                    <path className="cls-1" d="M3,1V8A6,6,0,0,0,15,8V1"/>
                                    <line className="cls-1" x1="1" y1="19" x2="17" y2="19"/>
                                </g>
                            </g>
                        </svg>
                    </button>

                </div>

            </div>

            <div className="title-format">Position</div>

            <div className="joystick-pos-container round-line-pos flexMiddle">
                <button
                    className="joystick left-black-joystick keep-click"
                    onClick={() => {
                        updateLine({
                            ...line,
                            rotation: line.rotation - 1,
                        });
                    }}
                ></button>
                <div className="col-1 flexJustify flexMiddle">
                    <button
                        className=""
                        onClick={() => {
                            updateLine({
                                ...line,
                                rotation: 0,
                            });
                        }}
                    >Centre</button>
                </div>
                <button
                    className="joystick right-black-joystick keep-click"
                    onClick={() => {
                        updateLine({
                            ...line,
                            rotation: line.rotation + 1,
                        });
                    }}
                ></button>
            </div>

            <div className="round-line-row">
                <div className="round-line-col">
                    <div className="title-format">Espacement</div>
                    <div className="joystick-espacement-container flexMiddle">
                        <button
                            className="joystick plus-joystick keep-click"
                            onClick={(e) => {
                                updateLine({
                                    ...line,
                                    letterSpacing: line.letterSpacing - 1,
                                });
                            }}
                        >-</button>
                        <button
                            className="joystick minus-joystick keep-click"
                            onClick={(e) => {
                                updateLine({
                                    ...line,
                                    letterSpacing: line.letterSpacing + 1,
                                });
                            }}
                        >+</button>
                    </div>
                </div>
                <div className="round-line-col">
                    <div className="title-format">Eloignement</div>
                    <div className="joystick-pos-container  flexMiddle">
                        <button
                            className="joystick up-black-joystick keep-click"
                            onClick={() => {
                                updateLine({
                                    ...line,
                                    offset: line.offset - 1,
                                });
                            }}
                        ></button>
                        <button
                            className="joystick down-black-joystick keep-click"
                            onClick={() => {
                                updateLine({
                                    ...line,
                                    offset: line.offset + 1,
                                });
                            }}
                        ></button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TextRoundLineEditor;